import { css, StyleSheet } from 'aphrodite'
import React from 'react'
import NavBar from './NavBar'
import { Link, useLocation } from 'wouter'
import { useState } from 'react'
import { isMobile, isMobileOnly } from 'react-device-detect'
import {
  useEnvironment,
  useHud,
  useLoader,
  useMaster,
  useSFDC,
} from '../../stores'
import LanguagePrompt from '../../components/icons/LanguagePrompt'
import HumburgerIcon from '../../components/icons/HamburgerIcon'
import CloseIcon from '../../components/icons/CloseIcon'
import DayNightToggle from '../lottie/DayNightToggle'
import { slideInRight, slideOutRight } from 'react-animations'
import { languageIndices, DisplayLocales } from '../../constants'
import { sendGAEvent } from '../../core/GoogleAnalytics'
import NavbarV01 from './NavbarV01'
import ModeDropdown from './ModeDropdown'
import ModeLoadingScreen from './ModeLoadingScreen'
// import ContinuaToggle from './ContinuaToggle'

export default function TopNavbar(props) {
  const { current, toggle } = useEnvironment()
  const [location] = useLocation()

  function DayNightClicked() {
    //0 - night
    //1 - day
    if (current === 0) {
      sendGAEvent('Day Night Toggle', 'Toggle', 'Night scene')
    } else {
      sendGAEvent('Day Night Toggle', 'Toggle', 'Day scene')
    }
  }

  return (
    <>
      {
        <div className={css(styles.container)}>
          <ModeLoadingScreen />
          {/* <div className={css(styles.row1)}> */}
          <BackButton
            data={
              props.data['back'] != null ? props.data['back'].title : 'BACK'
            }
          />
          {/* </div> */}
          <div className={css(styles.row1)}>
            <Logo />

            {/* <div className={css(styles.dayNightHolder)}>
                        <DayNightToggle onClick={toggle} direction={current == 0 ? -1 : 1} />
                    </div> */}

            {!isMobileOnly && (
              <>
                {/* <button className={css(styles.enterCar)}  onClick={() => setLocation('/frontpassengerseat')}>
                                Enter Car
                            </button> */}

                {/* <NavbarV01 /> */}
                {!location.includes('/continua') && (
                  <div className={css(styles.dayNightHolder)}>
                    <DayNightToggle
                      onClick={() => {
                        toggle()
                        DayNightClicked()
                      }}
                      direction={current === 0 ? -1 : 1}
                    />
                  </div>
                )}
                <NavBar />
              </>
            )}
            <ModeDropdown />
            <div
              className={css(styles.sideMenuContainer)}
              style={{ width: isMobileOnly && '100%' }}
            >
              {location !== '/' &&
                location !== '/frontpassengerseat' &&
                location !== '/driverseat' &&
                location !== '/rearseat' && (
                  <ContactButton
                    data={
                      props.data['contact'] != null
                        ? props.data['contact'].title
                        : 'Contact Us'
                    }
                  />
                )}
              <LanguageButton />
              {isMobileOnly && <HamburgerMenu />}
            </div>
          </div>
          {/* <LanguageOptions /> */}
        </div>
      }
    </>
    // }
  )
}

function Logo() {
  // const { categoriesClick } = useEnvironment()
  const [location] = useLocation()
  // const { current } = useEnvironment()
  // const Continua = useHud()

  // function OnLogoClick() {
  //   categoriesClick()
  //   if (current !== 0 && current !== 1) {
  //     Continua.setContinuaLoading(true)
  //   } else {
  //     Continua.setContinuaLoading(false)
  //   }
  // }

  return (
    <>
      <div className={css(styles.logoContainer)}>
        <Link
          href={location.includes('/continua') ? '/continua' : '/'}
          style={{ pointerEvents: 'auto' }}
          // onClick={() => location !== '/' && OnLogoClick()}
        >
          <img
            className={css(styles.image)}
            src="/images/BirlaCarbonLogo.jpg"
            alt="background"
            style={{ cursor: 'pointer' }}
          />
        </Link>
      </div>
    </>
  )
}

function ContactButton(props) {
  const { showForm, setShowForm } = useSFDC()
  const { setHideHotspots } = useHud()
  const formVisibility = useSFDC()

  function showContactForm() {
    sendGAEvent('Form', 'Click', 'Contact Us')
    // formVisibility.setShowForm(!formVisibility.showForm)
    setShowForm(!showForm)
    setHideHotspots(!showForm)
  }
  return (
    <>
      {useLoader.getState().everythingLoaded && (
        <div className={css(styles.subContainer, styles.contactContainer)}>
          <button
            className={css(styles.button)}
            onClick={() => {
              showContactForm()
            }}
          >
            {props.data}
            <svg
              className={css(styles.contactIcon)}
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.9214 0.647346C12.6971 0.696754 12.4712 0.737368 12.2607 0.81153C12.0938 0.868775 11.9634 0.973906 11.8787 1.12529C11.7866 1.2871 11.7321 1.4512 11.6989 1.62964C11.5286 2.54983 11.3508 3.48044 11.1715 4.40226C11.1441 4.56148 11.1062 4.71354 11.0879 4.87114C11.0637 5.04796 11.0831 5.20785 11.1945 5.3603C11.3456 5.57821 11.5116 5.77529 11.7181 5.93787C11.9882 6.14346 12.2509 6.35946 12.536 6.54422C12.5784 6.57289 12.6209 6.60156 12.6634 6.63023C12.847 6.76968 12.9148 6.93904 12.8517 7.15915C12.7914 7.34246 12.7401 7.52415 12.6692 7.70029C12.3914 8.38565 12.0817 9.04951 11.6903 9.67361C11.3286 10.256 10.9123 10.7938 10.443 11.2958C10.0603 11.7095 9.64266 12.0842 9.19001 12.4197C8.92776 12.6212 8.66394 12.8138 8.3895 12.9993C8.15707 13.1591 7.919 13.1838 7.67008 12.9925C7.14199 12.5973 6.60802 12.2213 6.11878 11.7828C6.05034 11.7134 5.96699 11.6649 5.88365 11.6163C5.73976 11.5423 5.59791 11.5315 5.45222 11.6031C5.15926 11.7375 4.90447 11.9285 4.64968 12.1196C3.91084 12.6791 3.18261 13.2457 2.44534 13.814C2.4214 13.8365 2.39588 13.8501 2.37193 13.8726C2.11556 14.0548 2.0164 14.2814 2.102 14.6019C2.21404 15.0175 2.3936 15.3937 2.59282 15.7754C2.76448 16.1076 3.02446 16.3604 3.33978 16.5579C3.56114 16.6996 3.78679 16.8134 4.02734 16.9063C4.67945 17.1612 5.35459 17.2849 6.06926 17.2653C6.5698 17.2479 7.03172 17.1195 7.4794 16.9119C8.18233 16.5676 8.85929 16.1827 9.51185 15.7658C9.84637 15.5513 10.1809 15.3369 10.5048 15.1152C11.0282 14.7579 11.5059 14.3543 11.9486 13.9116C12.5589 13.3117 13.104 12.66 13.5944 11.9636C13.9671 11.4427 14.3063 10.8916 14.626 10.3349C15.115 9.47536 15.4951 8.58098 15.8828 7.67618C16.2186 6.89869 16.4457 6.0863 16.5277 5.24553C16.5805 4.70955 16.5685 4.17615 16.4375 3.65507C16.1909 2.64646 15.6922 1.79211 14.8302 1.1483C14.5829 0.965838 14.3462 0.790549 14.0706 0.658554C13.7876 0.536977 13.5007 0.497785 13.1951 0.561813C13.1021 0.614855 13.0117 0.6311 12.9214 0.647346Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      )}
    </>
  )
}

function LanguageButton({ langText }) {
  const { languagePrompt, setLanguagePrompt } = useHud()
  const { setLocale } = useMaster()
  const [buttonText, setButtonText] = useState(
    DisplayLocales[languageIndices.english]
  )

  const showPrompt = () => {
    setLanguagePrompt(!languagePrompt)
  }

  function onLanguageSelect(ind) {
    setButtonText(DisplayLocales[ind])
    setLocale(ind)
  }

  return (
    <>
      <div className={css(styles.subContainer, styles.langContainer)}>
        <button
          className={css(styles.button, styles.langButton)}
          onClick={showPrompt}
        >
          <svg
            className={css(styles.langIcon)}
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.5 0C6.49687 0 6.49688 0 6.49375 0C6.49375 0 6.49375 0 6.49062 0C6.4875 0 6.48438 0 6.48438 0C2.9 0.009375 0 2.91563 0 6.5C0 10.0844 2.9 12.9906 6.48438 13C6.4875 13 6.49062 13 6.49062 13H6.49375C6.49688 13 6.49687 13 6.5 13C10.0906 13 13 10.0906 13 6.5C13 2.90937 10.0906 0 6.5 0ZM6.75937 3.89062C7.45 3.87188 8.11875 3.78125 8.76562 3.625C8.95938 4.39062 9.08125 5.275 9.1 6.24375H6.75937V3.89062ZM6.75937 3.36875V0.5625C7.45937 0.75625 8.17188 1.69062 8.62187 3.125C8.02187 3.26875 7.4 3.35 6.75937 3.36875ZM6.24062 0.55625V3.37187C5.59375 3.35312 4.96563 3.26875 4.3625 3.12187C4.81875 1.67812 5.53437 0.7375 6.24062 0.55625ZM6.24062 3.89062V6.24062H3.88438C3.90313 5.27187 4.025 4.3875 4.21875 3.62187C4.86875 3.77812 5.54688 3.87188 6.24062 3.89062ZM3.35938 6.24062H0.528125C0.584375 4.90312 1.08437 3.67812 1.88125 2.70937C2.45937 3.02812 3.075 3.29063 3.71875 3.48438C3.50625 4.3125 3.38125 5.24687 3.35938 6.24062ZM3.35938 6.75937C3.37812 7.75 3.50312 8.6875 3.71562 9.51562C3.07187 9.7125 2.45937 9.97187 1.87812 10.2906C1.08125 9.32187 0.584375 8.09687 0.525 6.75937H3.35938ZM3.88438 6.75937H6.24062V9.10625C5.54688 9.125 4.86875 9.21875 4.21875 9.37813C4.025 8.6125 3.90313 7.72812 3.88438 6.75937ZM6.24062 9.62813V12.4469C5.53437 12.2625 4.81875 11.325 4.3625 9.88125C4.96563 9.73125 5.59375 9.64688 6.24062 9.62813ZM6.75937 12.4375V9.625C7.4 9.64375 8.02188 9.72812 8.625 9.87187C8.17188 11.3094 7.4625 12.2437 6.75937 12.4375ZM6.75937 9.10625V6.75937H9.1C9.08125 7.725 8.95938 8.60938 8.76562 9.375C8.11875 9.21875 7.45 9.125 6.75937 9.10625ZM9.62187 6.75937H12.4719C12.4156 8.09687 11.9156 9.31875 11.1187 10.2906C10.5344 9.96875 9.91562 9.70625 9.26562 9.50937C9.47812 8.68125 9.60312 7.75 9.62187 6.75937ZM9.62187 6.24062C9.60312 5.25 9.47813 4.31563 9.26875 3.4875C9.91875 3.29063 10.5375 3.02812 11.1187 2.70937C11.9156 3.67812 12.4156 4.90312 12.4719 6.24375H9.62187V6.24062ZM10.7625 2.30938C10.2437 2.58438 9.7 2.8125 9.12813 2.98438C8.825 2.00625 8.39688 1.20938 7.89375 0.684375C9 0.95 9.9875 1.525 10.7625 2.30938ZM5.0875 0.690625C4.58437 1.2125 4.15938 2.00937 3.85938 2.98125C3.29375 2.80937 2.75312 2.58438 2.24062 2.30938C3.00625 1.52813 3.9875 0.95625 5.0875 0.690625ZM2.2375 10.6875C2.75 10.4125 3.29375 10.1875 3.85625 10.0156C4.15937 10.9906 4.58437 11.7844 5.0875 12.3094C3.9875 12.0437 3.00625 11.4719 2.2375 10.6875ZM7.89375 12.3156C8.4 11.7906 8.825 10.9937 9.13125 10.0125C9.70312 10.1844 10.2469 10.4125 10.7656 10.6875C9.99063 11.475 9 12.05 7.89375 12.3156Z"
              fill="white"
            />
          </svg>
          {buttonText}
          <svg
            className={css(styles.downArrow)}
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.353553"
              y1="0.646447"
              x2="5.35355"
              y2="5.64645"
              stroke="white"
            />
            <line
              x1="11.3536"
              y1="0.353553"
              x2="5.35355"
              y2="6.35355"
              stroke="white"
            />
          </svg>
        </button>
      </div>
      {languagePrompt && (
        <LanguageOptions
          onClick={onLanguageSelect}
          setLanguagePrompt={setLanguagePrompt}
          buttonText={buttonText}
        />
      )}
    </>
  )
}
function HamburgerMenu() {
  const { openNav, setOpenNav, setHideHotspots } = useHud()
  const { showForm, setShowForm } = useSFDC()

  function openNavbar() {
    if (showForm) {
      setShowForm(false)
    }
    setOpenNav(!openNav)
    setHideHotspots(true)
  }

  if (useHud.getState().openNav) {
    return (
      <>
        <div className={css(styles.subContainer)}>
          <button className={css(styles.button)} onClick={() => openNavbar()}>
            <HumburgerIcon />
          </button>
          <Drawer />
        </div>
      </>
    )
  } else {
    return (
      <>
        <div className={css(styles.subContainer)}>
          <button className={css(styles.button)} onClick={() => openNavbar()}>
            <HumburgerIcon />
          </button>
        </div>
      </>
    )
  }
}
function Drawer() {
  const { setOpenNav, setHideHotspots } = useHud()
  const { data } = useMaster()
  const { current, toggle } = useEnvironment()
  const [slideOut, setSlideOut] = useState(false)
  const [location] = useLocation()

  function slideOutAnim() {
    setSlideOut(true)
    // console.log("fadeAnim")
  }

  function closeMenu() {
    setOpenNav(false)
    setHideHotspots(false)
    setSlideOut(false)
  }
  return (
    <>
      {/* {console.log("Hamburger Clicked")} */}
      <div className={css(styles.menuContainer)}>
        <div
          className={css(
            styles.menuSubContainer,
            slideOut ? styles.closeMenuAnim : styles.openMenuAnim
          )}
        >
          <button
            className={css(styles.closeButton)}
            onClick={() => slideOutAnim(setTimeout(() => closeMenu(), 500))}
          >
            <CloseIcon />
          </button>
          {!location.includes('/continua') && (
            <div className={css(styles.toggle)}>
              <DayNightToggle
                direction={current === 0 ? -1 : 1}
                onClick={toggle}
              />
            </div>
          )}

          <div className={css(styles.contentOverflow)}>
            {Object.keys(
              location.includes('/continua')
                ? data.continuaCategories
                : data.categories
            ).map((key, index) => {
              let dat = location.includes('/continua')
                ? data.continuaCategories[key]
                : data.categories[key]
              let href = dat.target
              return (
                <Link
                  key={index}
                  className={css(styles.link)}
                  href={href}
                  onClick={() => {
                    setOpenNav(false)
                  }}
                >
                  {dat.display === 'Continua' ? (
                    <img
                      src={dat.src}
                      className={css(
                        location.includes('/continua')
                          ? styles.continuaSelected
                          : styles.linkFont,
                        styles.linkFont,
                        styles.link,
                        styles.continuaButton
                      )}
                      style={{
                        height: 'auto',
                        width: '100%',
                        cursor: 'pointer',
                        // background: 'red',
                      }}
                      // onClick={ToggleContinua}
                      alt="continua_logo"
                    />
                  ) : (
                    dat.display
                  )}
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

function LanguageOptions(props) {
  const { locale } = useMaster()
  return (
    <>
      <div className={css(styles.languagePromptContainer)}>
        <div className={css(styles.promptButtonContainer)}>
          <button
            onClick={() => {
              props.onClick(languageIndices.chinese)
              props.setLanguagePrompt(false)
            }}
            // disabled={location.includes('/continua') ? true : false}
            // disabled
            className={css(
              styles.promptButton,
              styles.china
              // props.buttonText ? styles.highlightText : styles.textColor
            )}
            style={{
              color: locale === 'zh-CN' ? '#000000' : '#474747',
              fontWeight: locale === 'zh-CN' ? 'bold' : 'normal',
              cursor: locale === 'zh-CN' ? 'default' : 'pointer',
            }}
          >
            中文
          </button>
          <button
            onClick={() => props.onClick(languageIndices.spanish)}
            disabled
            className={css(styles.promptButton, styles.spain)}
            style={{
              color: '#474747',
              fontWeight: 'normal',
              cursor: 'default',
            }}
          >
            español
          </button>
          <button
            onClick={() => {
              props.onClick(languageIndices.english)
              props.setLanguagePrompt(false)
            }}
            // disabled
            className={css(styles.promptButton, styles.english)}
            style={{
              color: locale === 'en' ? '#000000' : '#474747',
              fontWeight: locale === 'en' ? 'bold' : 'normal',
              cursor: locale === 'en' ? 'default' : 'pointer',
            }}
          >
            English
          </button>
          <button
            onClick={() => props.onClick(languageIndices.portuguese)}
            disabled
            className={css(styles.promptButton, styles.portuguese)}
            style={{
              color: '#474747',
              fontWeight: 'normal',
              cursor: 'pointer',
            }}
          >
            Portuguese
          </button>
        </div>
        <div className={css(styles.svgContainer)}>
          <LanguagePrompt />
        </div>
      </div>
    </>
  )
}

function BackButton(props) {
  const [location, setLocation] = useLocation()
  const { showForm, setShowForm } = useSFDC()

  function onBack() {
    if (showForm) {
      setShowForm(false)
    }
    let split = location.split('/')
    let length = split.length
    let final = split[0]
    for (var i = 1; i < length - 1; i++) {
      final = final + '/' + split[i]
    }
    if (final === '') {
      final = '/'
    }
    setLocation(final)

    // window.history.back()
  }

  return (
    <>
      {location !== '/' && location !== '/continua' && (
        <div className={css(styles.backButtonContainer)}>
          <button onClick={onBack} className={css(styles.backButton)}>
            <svg
              className={css(styles.backIcon)}
              width="15"
              height="25"
              viewBox="0 0 15 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="12.2049"
                y1="22"
                x2="2.55873"
                y2="12.3539"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="12.791"
                y1="2.12132"
                x2="3.1449"
                y2="11.7674"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {!isMobileOnly && props.data}
          </button>
        </div>
      )}
    </>
  )
}

export { TopNavbar, Drawer }

const styles = StyleSheet.create({
  dayNightHolder: {
    display: 'flex',
    marginLeft: 50,
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:landscape)':
      {
        marginLeft: 10,
      },
    '@media(min-width: 1200px) and (max-width: 1399.98px) and (orientation:landscape)':
      {
        marginLeft: 20,
      },
    '@media(min-width: 1440px)': {
      marginLeft: 30,
    },
    '@media(min-width: 2560px)': {
      marginLeft: 50,
    },
  },
  enterCar: {
    color: 'white',
    textAlign: 'center',
    border: '1px solid white',
    marginTop: 35,
    height: 50,
    paddingTop: 5,
    width: 90,
    background: 'none',
    pointerEvents: 'auto',
    ':hover': {
      opacity: 0.6,
    },
    ':active': {
      opacity: 1,
    },
    '@media(max-width: 992px) ': {
      display: 'none',
    },
  },
  openMenuAnim: {
    animationName: [slideInRight],
    animationDuration: '1s, 300ms',
  },
  closeMenuAnim: {
    animationName: [slideOutRight],
    animationDuration: '1s, 300ms',
  },
  toggle: {
    marginTop: 0,
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {},
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    height: 200,
    width: '100%',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    pointerEvents: 'none',
    backgroundImage:
      'linear-gradient(180deg, #121212 20.38%, rgba(114, 114, 114, 0) 70.82%)',
    // backgroundColor: 'black',
    border: 'none',
    outline: 'none',

    '@media(max-width: 575.98px) and (orientation:portrait)': {
      display: 'none',
    },

    '@media(max-width: 575.98px) and (orientation:landscape)': {
      height: 100,
      // backgroundColor: 'red',
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        height: 120,
      },
    '@media(max-width: 768px) and (orientation:portrait)': {
      display: 'none',
    },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        height: 120,
      },
    '@media(max-width: 992px) and (orientation:portrait)': {
      display: 'none',
    },
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:landscape)':
      {
        height: 150,
      },
    '@media(min-width: 1200px) and (max-width: 1399.98px) and (orientation:landscape)':
      {
        height: 150,
      },

    //Laptops & larger screens
    '@media(min-width: 992px) and (max-width: 1199.98px)': {
      height: 150,
    },
    '@media(min-width: 1200px) and (max-width: 1399.98px)': {
      height: 150,
    },
    '@media(min-width: 1400px) and (max-width: 1599.98px)': {
      // height:200,
    },
    '@media(min-width: 1600px) and (max-width: 2559.98px)': {
      height: 300,
    },
    '@media(min-width: 2560px)': {
      height: 300,
    },
  },
  row1: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    // backgroundColor: 'red',
  },
  logoContainer: {
    display: 'flex',
    width: 159,
    height: 153,
    backgroundColor: '#ffffff',
    // borderBottomRightRadius: 10,
    pointerEvents: 'auto',

    '@media(max-width: 575.98px)': {
      height: 50,
      width: 60,
      // borderBottomRightRadius: 6,
      // backgroundColor: 'red',
    },
    '@media(max-width: 575.98px) and (orientation:landscape)': {
      height: 50,
      width: 60,
      // borderBottomRightRadius: 6,
      // backgroundColor: 'red',
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        height: 60,
        width: 70,
        // borderBottomRightRadius: 6,
      },
    '@media(min-width: 576px) and (max-width: 768.98px)': {
      height: 60,
      width: 70,
      // borderBottomRightRadius: 6,
    },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        height: 60,
        width: 70,
        // borderBottomRightRadius: 6,
      },
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:landscape)':
      {
        height: 110,
        width: 120,
      },

    '@media(min-width: 1200px) and (max-width: 1399.98px) and (orientation:landscape)':
      {
        height: 130,
        width: 140,
      },

    //Laptops & larger screens
    '@media(min-width: 992px) and (max-width: 1199.98px)': {
      height: 110,
      width: 120,
    },
    '@media(min-width: 1200px) and (max-width: 1399.98px)': {
      height: 130,
      width: 140,
    },
    '@media(min-width: 1400px) and (max-width: 1599.98px)': {
      height: 130,
      width: 140,
    },
    '@media(min-width: 1600px) and (max-width: 2559.98px)': {
      height: 153,
      width: 159,
    },
    '@media(min-width: 2560px)': {
      height: 173,
      width: 179,
    },
  },

  image: {
    width: 159,
    height: 153,
    // borderBottomRightRadius: 10,

    '@media(max-width: 575.98px)': {
      height: 50,
      width: 60,
      // borderBottomRightRadius: 6,
      // backgroundColor: 'red',
    },
    '@media(max-width: 575.98px) and (orientation:landscape)': {
      height: 50,
      width: 60,
      // borderBottomRightRadius: 6,
      // backgroundColor: 'red',
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        height: 60,
        width: 70,
        // borderBottomRightRadius: 6,
      },
    '@media(min-width: 576px) and (max-width: 768.98px)': {
      height: 60,
      width: 70,
      // borderBottomRightRadius: 6,
    },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        height: 60,
        width: 70,
        // borderBottomRightRadius: 6,
      },
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:landscape)':
      {
        height: 110,
        width: 120,
      },
    '@media(min-width: 1200px) and (max-width: 1399.98px) and (orientation:landscape)':
      {
        height: 130,
        width: 140,
      },
    //Laptops & larger screens
    '@media(min-width: 992px) and (max-width: 1199.98px)': {
      height: 110,
      width: 120,
    },
    '@media(min-width: 1200px) and (max-width: 1399.98px)': {
      height: 130,
      width: 140,
    },
    '@media(min-width: 1400px) and (max-width: 1599.98px)': {
      height: 130,
      width: 140,
    },
    '@media(min-width: 1600px) and (max-width: 2559.98px)': {
      height: 153,
      width: 159,
    },
    '@media(min-width: 2560px)': {
      height: 173,
      width: 179,
    },
  },
  sideMenuContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    // width: '100%',
    // backgroundColor: 'blue',

    '@media(min-width: 992px) and (orientation:landscape)': {
      // width: '30%',
      // backgroundColor: 'red',
    },
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: 100,
    width: 120,
    // backgroundColor: 'pink',
    '@media(max-width: 575.98px) and (orientation:portrait)': {
      display: 'none',
      // backgroundColor: 'blue',
    },
    '@media(max-width: 575.98px) and (orientation:landscape)': {
      width: 50,
      height: 50,

      // backgroundColor: 'blue',
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:portrait)':
      {
        display: 'none',
      },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        width: 50,
        height: 50,
      },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:portrait)':
      {
        display: 'none',
      },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        width: 50,
        height: 50,
      },
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:portrait)':
      {
        display: 'none',
      },
    '@media(min-width: 1200px) and (max-width: 1399.98px)': {
      width: 100,
      height: 100,
      // backgroundColor: 'blue'
    },
    '@media(min-width: 1600px) and (max-width: 2559.98px)': {
      // paddingTop: 40,

      width: 150,
    },
    '@media(min-width: 2560px)': {
      // fontSize: 20,
      width: 250,
    },
  },
  contactContainer: {
    // '@media(max-width: 575.98px)': {
    //     marginLeft : 30
    // },
    // '@media(min-width: 1600px) and (max-width: 2559.98px)': {
    //     marginLeft : 100
    // },
  },
  langContainer: {
    '@media(max-width: 575.98px) and (orientation:landscape)': {
      marginRight: 20,
      // width: 50,
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        marginRight: 20,
        // backgroundColor: 'blue',
      },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        marginRight: 20,
      },
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:landscape)':
      {
        marginRight: 10,
      },
    '@media(min-width: 1200px) and (max-width: 1399.98px) and (orientation:landscape)':
      {
        marginRight: 20,
      },
    '@media(min-width: 992px) and (max-width: 1199.98px)': {
      marginRight: 10,
    },
    '@media(min-width: 1200px) and (max-width: 1399.98px)': {
      marginRight: 20,
    },
    '@media(min-width: 1400px) and (max-width: 1599.98px)': {
      marginRight: 20,
    },
    '@media(min-width: 1600px) and (max-width: 2559.98px)': {
      marginRight: 30,
    },
    '@media(min-width: 2560px)': {
      marginRight: 30,
    },
  },
  button: {
    border: 0,
    outline: 0,
    textAlign: 'center',
    color: '#ffffff',
    fontFamily: 'Oxygen-Regular',
    fontSize: 15,
    lineHeight: '35px',
    fontWeight: 'normal',
    pointerEvents: 'auto',
    cursor: 'pointer',
    width: 120,
    height: 50,
    background: 'none',
    // backgroundColor: 'black',
    marginTop: 35,
    '@media(max-width: 575.98px) and (orientation:landscape)': {
      fontSize: 0,
      width: 50,
      height: 30,
      marginTop: 10,
      cursor: 'none',
      // backgroundColor: 'black',
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        fontSize: 0,
        width: 50,
        height: 30,
        marginTop: 10,
        cursor: 'none',
      },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        fontSize: 0,
        width: 50,
        height: 30,
        marginTop: 10,
        cursor: 'none',
      },
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:landscape)':
      {
        fontSize: 14,
      },
    '@media(min-width: 1200px) and (max-width: 1399.98px)': {
      fontSize: 13,
      width: 100,
    },
    '@media(min-width: 1600px) and (max-width: 2559.98px)': {
      // paddingTop: 40,
      fontSize: 18,
      width: 150,
    },
    '@media(min-width: 2560px)': {
      fontSize: 23,
      width: 250,
      height: 60,
      marginTop: 40,
    },
  },
  contactIcon: {
    marginLeft: 5,
    marginBottom: -2,
    width: 19,
    height: 18,
    '@media(min-width: 2560px)': {
      width: 29,
      height: 25,
    },
  },
  langButton: {
    borderLeft: '1px solid #ffffff',
    borderBottom: 0,
    borderRight: 0,
    borderTop: 0,
  },
  langIcon: {
    marginRight: 5,
    marginBottom: -2,
    width: 13,
    height: 13,
    '@media(min-width: 2560px)': {
      width: 20,
      height: 20,
    },
  },
  downArrow: {
    marginLeft: 5,
    width: 12,
    height: 7,
    '@media(min-width: 2560px)': {
      width: 22,
      height: 17,
    },
  },
  backButtonContainer: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: 80,
    marginLeft: `${isMobile ? '1.5vw' : '1.8vw'}`,
    top: `${isMobileOnly ? '8vw' : isMobile ? '10vw' : '10vw'}`,
    // background: 'red',
    // margin: 0,
    // background: 'red',
    padding: 0,
    // width: '100%',
    '@media(max-width: 575.98px) and (orientation:portrait)': {
      display: 'none',
    },
    '@media(max-width: 575.98px) and (orientation:landscape)': {
      width: 50,
      height: 'auto',
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:portrait)':
      {
        display: 'none',
      },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        width: 50,
        height: 'auto',
      },
    '@media(min-width: 576px) and (max-width: 768.98px)': {
      width: 50,
      height: 'auto',
    },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:portrait)':
      {
        display: 'none',
      },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        width: 50,
        height: 'auto',
      },
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:portrait)':
      {
        display: 'none',
      },
  },
  backButton: {
    border: 0,
    outline: 0,
    textAlign: 'center',
    color: '#ffffff',
    fontFamily: 'Oxygen-Regular',
    // fontSize: 25,
    // lineHeight: '35px',
    fontWeight: 'normal',
    pointerEvents: 'auto',
    cursor: 'pointer',
    fontSize: '2vw',
    // width: 150,
    // height: 80,
    background: 'none',
    textDecoration: 'none',
    // backgroundColor: 'black',
    margin: 0,
    padding: 0,
    marginTop: 0,
    '@media(max-width: 575.98px) and (orientation:landscape)': {
      height: 'auto',
      // cursor: 'none',
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        height: 'auto',
        // cursor: 'none',
      },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        height: 'auto',
        // cursor: 'none',
      },
    '@media(min-width: 992px)': {
      fontSize: '2.1vw',
    },
    '@media(min-width: 1200px)': {
      fontSize: 25,
      lineHeight: '35px',
    },
    '@media(min-width: 2560px)': {
      fontSize: 32,
      lineHeight: '35px',
    },
  },
  backIcon: {
    marginRight: 10,
    marginBottom: -5,
  },

  languagePromptContainer: {
    width: 110,
    height: 91,
    position: 'absolute',
    // backgroundColor: 'blue',
    // marginLeft: '90%',
    marginTop: 80,
    '@media(max-width: 575.98px) and (orientation:landscape)': {
      marginTop: 50,
      marginRight: 50,
      zIndex: 5,
    },
    '@media(min-width: 576px) and (max-width: 768.98px) and (orientation:landscape)':
      {
        marginTop: 40,
        marginRight: 50,
        zIndex: 5,
      },
    '@media(min-width: 768px) and (max-width: 991.98px) and (orientation:landscape)':
      {
        marginTop: 40,
        marginRight: 50,
        zIndex: 5,
      },
    '@media(min-width: 992px) and (max-width: 1199.98px) and (orientation:landscape)':
      {
        marginTop: 80,
        marginRight: 10,
      },
    '@media(min-width: 1200px) and (max-width: 1399.98px) and (orientation:landscape)':
      {
        marginTop: 80,
        marginRight: 20,
      },
    '@media(min-width: 992px) and (max-width: 1199.98px)': {
      marginTop: 80,
      marginRight: 10,
    },
    '@media(min-width: 1200px) and (max-width: 1399.98px)': {
      marginTop: 80,
      marginRight: 20,
    },
    '@media(min-width: 1400px) and (max-width: 1599.98px)': {
      marginTop: 80,
      marginRight: 20,
    },
    '@media(min-width: 1600px) and (max-width: 2559.98px)': {
      marginTop: 80,
      marginRight: 40,
    },
    '@media(min-width: 2560px)': {
      marginTop: 80,
      marginRight: 90,
    },
  },
  promptButtonContainer: {
    position: 'absolute',
    zIndex: 1,
    width: 110,
    height: 90,
    marginTop: 15,
    marginLeft: 'auto',
    marginRight: 'auto',
    // backgroundColor: 'red',
    '@media(min-width: 2560px)': {
      height: 130,
    },
  },
  promptButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    borderBottom: '1px solid #C7C7C7',
    borderTop: 0,
    borderLeft: 0,
    borderRight: 0,
    outline: 0,
    textAlign: 'left',
    // color: '#474747',
    fontFamily: 'Oxygen-Regular',
    fontSize: 12,
    textIndent: 35,
    // fontWeight: 'normal',
    pointerEvents: 'auto',
    // cursor: 'default',
    width: 90,
    height: 25,
    padding: 0,
    marginLeft: 12,
    backgroundColor: 'none',
  },
  china: {
    // display: 'inline-block',
    background: 'url(/images/china.jpg) top left',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0px 6px',
    // verticalAlign: 'middle'
  },
  spain: {
    background: 'url(/images/spain.jpg) top left',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0px 5px',
  },
  english: {
    background: 'url(/images/uk.jpg) top left',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0px 8px',
    // border: 0
  },
  portuguese: {
    background: 'url(/images/portuguese.jpg) top left',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0px 10px',
    border: 0,
  },
  svgContainer: {
    width: 110,
    height: 91,
    position: 'absolute',
  },
  menuContainer: {
    background: 'rgba(112, 112, 112, 0.69)',
    width: '100%',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: '100%',
    zIndex: 5,
  },
  menuSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#3B3B3B',
    textAlign: 'left',
    width: 210,
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,

    // height: '100%',
  },
  continuaButton: {
    width: '40vh',
    // height: 'auto',
  },
  contentOverflow: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '55vh',
    marginBottom: '8vh',
    overflowY: 'auto',
    pointerEvents: 'auto',
  },
  link: {
    fontSize: 12,
    color: '#ffffff',
    textDecoration: 'none',
    fontWeight: 'normal',
    paddingLeft: 60,
    paddingBottom: 12,
    paddingTop: 10,
    pointerEvents: 'auto',
    // backgroundColor: 'blue',
  },
  closeButton: {
    background: 'none',
    border: 0,
    outline: 0,
    width: 60,
    height: 70,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 150,
    padding: 0,
    pointerEvents: 'auto',
    cursor: 'pointer',
    // backgroundColor: 'red'
  },
})
